<template>
  <Modal
      v-model="_value"
      width="500"
      title="批量追加车辆业务笔记"
      @on-visible-change="visibleChange"
      ok-text="关闭"
      cancel-text="">
    <Form ref="businessNoteForm" :model="businessNoteInfo" style="display: inline;">
      <FormItem prop="content">
        <label style="display: inline-block; width: 60px;">笔记内容</label>
        <Input style="display: inline-block; width: 400px;" type="textarea"
               v-model="businessNoteInfo.content" placeholder="请输入笔记内容">
        </Input>
      </FormItem>
    </Form>
    <Row style="text-align: right;">
      <Button type="primary" @click="batchAdd">追加</Button>
    </Row>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'batchaddvehicleinfobusinessnotemodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        businessNoteInfo: {
          id: null,
          content: null
        }
      }
    },
    methods: {
      ...mapActions([
        'VehicleInfoGroupServ_BatchAddBusinessNotes'
      ]),
      formatDate(val) {
        if (val) {
          let d = new Date(val)
          return d.Format('yyyy年MM月dd日 hh:mm:ss')
        } else {
          return '无'
        }
      },
      batchAdd() {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确认批量添加业务笔记</p>',
          onOk: () => {
            store.dispatch('VehicleInfoGroupServ_BatchAddBusinessNotes', {
              params: this.businessNoteInfo,
              urlparams: null
            }).then(() => {
              this.$Message.success('追加成功')
            }).catch(err => {
              this.$Message.error(err)
            })
          },
          onCancel: () => {

          }
        })
      },
      visibleChange(val) {
        if (val) {
          this.businessNoteInfo.id = this._initValue
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
